import React from 'react'
import { Typography } from '@mui/material'
import { WarningOutlined } from '@mui/icons-material'
import theme from '../theme'

interface Props {
  error?: string
}

const InputErrorMessage = ({ error }: Props) => {
  return (
    <Typography
      color={theme.palette['red-500']}
      variant="body-8"
      sx={{
        mt: 1,
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <WarningOutlined fontSize="inherit" sx={{ marginRight: '5px' }} />
      {error}
    </Typography>
  )
}

export default InputErrorMessage
